import React, { FC } from 'react'


interface DeleteAbsoluteButtonProps {
	onClick?: () => void;
	className?: string;
	label?: string
}


const DeleteAbsoluteButton: FC<DeleteAbsoluteButtonProps> = ({ onClick, className = '', label = '' }) => {

	const handleClick = (event: React.MouseEvent) => {
		event.stopPropagation()
		if (onClick) {
			onClick()
		}
	}

	return (
		<div
			className={`bg-transparent hover:bg-red-500 hover:text-white active:bg-red-600 active:text-white text-red-500 text-sm  absolute top-xs right-xs w-[35px] h-[35px] transition-all rounded-md flex items-center justify-center cursor-pointer gap-sm ${className}`}
			onClick={handleClick}
		>
            <span className={"font-icon-regular"}></span>
			{label && <span className={"text-text-md"}>{label}</span>}
		</div>
	)
}

export default DeleteAbsoluteButton
